import { render, staticRenderFns } from "./sos_list.vue?vue&type=template&id=4882e3d0&scoped=true&"
import script from "./sos_list.vue?vue&type=script&lang=js&"
export * from "./sos_list.vue?vue&type=script&lang=js&"
import style0 from "./sos_list.vue?vue&type=style&index=0&id=4882e3d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4882e3d0",
  null
  
)

export default component.exports